import Container from "@client/content/Containers/Item/container";
import { type ItemContainerProps } from "@client/content/types";
import Image from "@client/controls/Image/component";
import * as React from "react";

export type ImageGalleryItemMapProps = ItemContainerProps & {
  className: string;
  imageSrc: string;
};

export interface ImageGalleryItemActionProps {
  onClick: () => void;
}

export default ({ className, onClick, imageSrc, ...props }: ImageGalleryItemActionProps & ImageGalleryItemMapProps) => (
  <div className={className} onClick={onClick}>
    <Container {...props}>
      <Image src={imageSrc} />
    </Container>
  </div>
);
